<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">
			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span *ngIf="!news.id">Newserstellung</span>
				<span *ngIf="news.id">Newsausgabe</span>
			</div>
			<mat-spinner diameter=30 [ngStyle]="{ opacity: bInProgress ? '1' : '0' }" />
		</div>

		<form [formGroup]="formG1">
		
			<div style="display: flex; flex-flow: column nowrap; gap: 1em; align-items: center;">

				<div class="fieldsMaxWidth">

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_title"
					></triv-input>

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_rubrics"
					></triv-input>

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_categories"
					></triv-input>

				</div>

				<div class="fieldsMaxWidth">

					<div class="partnerLabel">Ansprechpartner</div>

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_contactTitle"
					></triv-input>

					
					<div class="twoFields">
						
						<triv-input 
							[fGroup]="formG1" 
							[data]="myInputs.news_contactFamilyName"
						></triv-input>
						<triv-input 
							[fGroup]="formG1" 
							[data]="myInputs.news_contactFirstName"
						></triv-input>

					</div>

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_contactPhone"
					></triv-input>

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_contactEmail"
					></triv-input>

					<div style="margin: 2em 0 2em 0">
						<triv-input 
							[fGroup]="formG1" 
							[data]="myInputs.news_external"
						></triv-input>
					</div>

					<triv-input 
						[fGroup]="formG1" 
						[data]="myInputs.news_url"
						[ngStyle]="{ display: bExternal ? 'block' : 'none' }"
					></triv-input>

				</div>

				<div
					style="display: flex; flex-flow: column nowrap; margin: 2em 0; width: 100%; max-width: 900px;"
					[ngStyle]="{ display: bExternal ? 'none' : 'flex' }"
				>

					<ngx-editor-menu
						[editor]="editor"
						[toolbar]="toolbar"
					></ngx-editor-menu>

					<ngx-editor
						[editor]="editor"
						[placeholder]="'Inhalt der Nachrichten'"
						formControlName="news_content"
						(ngModelChange)="onDescriptionChange($event)"
					></ngx-editor>

				</div>

				<div
					fileDragDrop
					(fileDropped)="trivInputFileUploader.onFileAdd($event)"
					class="dragDropArea fieldsMaxWidth"
				>
					<div class="labelLine">Angehängte Dateien</div>

					<div *ngIf="attachedFiles.length">

						<div
							*ngFor="let attachedFile of attachedFiles"
							class="fileLine"
						>
							<div class="fileNameAndDelete">
								<span
									class="fileName"
									(click)="downloadFile(attachedFile)"
								>
									{{attachedFile.file.name}}
								</span>
								<span
									*ngIf="attachedFile.id"
									(click)="deleteFile(attachedFile)"
									class="material-icons deleteBtn"
								>delete</span>
								<span *ngIf="!attachedFile.id && attachedFile.percentageUploaded != 100">{{attachedFile.percentageUploaded}}%</span>
							</div>
			
							<mat-progress-bar
								*ngIf="news.id && attachedFile.percentageUploaded && attachedFile.percentageUploaded != 100"
								mode="determinate"
								[value]="attachedFile.percentageUploaded"
							></mat-progress-bar>
			
						</div>

					</div>

					<triv-input
						#trivInputFileUploader
						[fGroup]="formG1"
						[data]="myInputs.news_fileUploader"
						(fileChosen)="aFileWasChosen($event)"
						(filesChosen)="filesWereChosen($event)"
						[bDropInComponentEnabled]="false"
					></triv-input>

				</div>


				<div class="btnPanel fieldsMaxWidth">

					<last-save-msg
						*ngIf="tmsLastSaveStart"
						[tmsLastSaveStart]="tmsLastSaveStart"
						[tmsLastSaveEnd]="tmsLastSaveEnd"
					></last-save-msg>

					<div class="btnLine">

						<button
							*ngIf="news.id"
							mat-raised-button
							type="button"
							(click)="clickDelete()"
							[disabled]="bInProgress"
						>
							<span class="material-icons" style="margin-right: .5em">delete</span>
							<span>Löschen</span>
						</button>

						<button
							mat-raised-button
							type="button"
							color="primary"
							(click)="clickPublish()"
							[disabled]="!formG1.valid || bInProgress"
						>
							<span class="material-icons" style="margin-right: .5em">cell_tower</span>
							<span>{{ !news.bReleased ? 'Freigeben' : 'Änderungen senden' }}</span>
						</button>

					</div>

					<mat-progress-bar
						mode="indeterminate"
						[ngStyle]="{opacity: bInProgress ? 1 : 0}"
					></mat-progress-bar>

				</div>

			</div>

		</form>

	</div>

</div>

